export const AUTHENTICATED = 'components/legacy-reset/AUTHENTICATED';

export const authenticated = () => ({
  type: AUTHENTICATED,
});
